import DOMPurify from 'isomorphic-dompurify';

const RICH_HTML_DEFAULTS = {
  USE_PROFILES: { html: true },
  ALLOW_DATA_ATTR: false,
  FORBID_TAGS: ['style', 'script', 'iframe', 'object', 'embed']
};

const PLAIN_TEXT_DEFAULTS = {
  ALLOWED_TAGS: [],
  ALLOWED_ATTR: []
};

export function sanitizeRichHtml(html: string, options?: any): string {
  return String(DOMPurify.sanitize(html, { ...RICH_HTML_DEFAULTS, ...(options || {}) }));
}

export function sanitizePlainText(html: string, options?: any): string {
  return String(DOMPurify.sanitize(html, { ...PLAIN_TEXT_DEFAULTS, ...(options || {}) }));
}

// Entity-escape a value before interpolating it into a raw HTML string (e.g. a Highcharts
// `useHTML` label/tooltip built by string concatenation, where React's auto-escaping doesn't apply).
export function escapeHtml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
